import type { ComponentType } from "react";
import { Navigate } from "react-router-dom";

import { showErrorToast } from "src/lib/utils";
import type { PermissionCheck } from "src/types/auth";
import useHasPermissions from "./useHasPermissions";

/** Route guard: redirects to the dashboard when the user lacks `permission`. */
const withPermissionWrapper = <P extends object>(WrappedComponent: ComponentType<P>, permission: PermissionCheck) =>
	function EnhancedComponent(props: P) {
		const hasPermission = useHasPermissions(permission);

		if (!hasPermission) {
			showErrorToast("You don't have permissions for this action");
			return <Navigate to="/" />;
		}

		return <WrappedComponent {...props} />;
	};

export default withPermissionWrapper;
